import { render, staticRenderFns } from "./Porfolio1.vue?vue&type=template&id=b6bc008a&scoped=true&"
import script from "./Porfolio1.vue?vue&type=script&lang=js&"
export * from "./Porfolio1.vue?vue&type=script&lang=js&"
import style0 from "./Porfolio1.vue?vue&type=style&index=0&id=b6bc008a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bc008a",
  null
  
)

export default component.exports